module.exports = __webpack_public_path__ + "static/media/bilbao-gonzalo.8d61925c.jpg";